import { Trans } from 'react-i18next';

const FORM_ERROR_MESSAGES = {
  addressRequired: <Trans i18nKey="addressRequired" />,
  cityRequired: <Trans i18nKey="cityRequired" />,
  emailRequired: <Trans i18nKey="emailRequired" />,
  locationRequired: <Trans i18nKey="locationRequired" />,
  firstNameRequired: <Trans i18nKey="firstNameRequired" />,
  lastNameRequired: <Trans i18nKey="lastNameRequired" />,
  senderNameRequired: <Trans i18nKey="senderNameRequired" />,
  giftMessageRequired: <Trans i18nKey="giftMessageRequired" />,
  paymentMethodRequired: <Trans i18nKey="paymentMethodRequired" />,
  verificationTypeRequired: <Trans i18nKey="securitySettingRequired" />,
  stateRequired: <Trans i18nKey="stateRequired" />,
  phoneRequired: <Trans i18nKey="phoneRequired" />,
  zipCodeRequired: <Trans i18nKey="zipCodeRequired" />,
  endDateRequired: <Trans i18nKey="recognitionEndDateRequired" />,
  recognitionNameRequired: <Trans i18nKey="recognitionNameRequired" />,
  requiredField: <Trans i18nKey="requiredField" />,
  invalidEmail: <Trans i18nKey="invalidEmail" />,
  invalidName: <Trans i18nKey="invalidName" />,
  invalidPhone: <Trans i18nKey="invalidPhone" />,
  max20Char: <Trans i18nKey="maxCountChars" values={{ count: 20 }} />,
  max30Char: <Trans i18nKey="maxCountChars" values={{ count: 30 }} />,
  max50Char: <Trans i18nKey="maxCountChars" values={{ count: 50 }} />,
  max100Char: <Trans i18nKey="maxCountChars" values={{ count: 100 }} />,
  max500Char: <Trans i18nKey="maxCountChars" values={{ count: 500 }} />,
  min2Char: <Trans i18nKey="minCountChars" values={{ count: 2 }} />,
  min4Char: <Trans i18nKey="minCountChars" values={{ count: 4 }} />,
  min8Char: <Trans i18nKey="minCountChars" values={{ count: 8 }} />,
  min10Char: <Trans i18nKey="minCountChars" values={{ count: 10 }} />,
  minEndDate: <Trans i18nKey="endDateMustBeLaterThanNow" />,
  recognitionNameMaxLimit: <Trans i18nKey="recognitionMustBe100Char" />,
  senderNameMaxLimit: <Trans i18nKey="senderMustBe50Char" />,
  additionalTextMaxLimit: <Trans i18nKey="additionalMustBe500Char" />,
  emailDomainsMinLimitText: <Trans i18nKey="youShouldAddAtLeast1EmailDomain" />,
  invalidFirstName: <Trans i18nKey="errors.invalidFirstName" />,
  invalidLastName: <Trans i18nKey="errors.invalidLastName" />,
  invalidBirthday: <Trans i18nKey="invalidBirthday" />,
  invalidAnniversary: <Trans i18nKey="invalidAnniversary" />
};

export { FORM_ERROR_MESSAGES };
